import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { AntDesign } from '@expo/vector-icons';

/** ================================
*  定数
*  ================================*/

export const cognitoGroup = {
  admins: 'Admins',
  instructor: 'Instructor',
  producer: 'Producer',
}

// ダイアログヘッダ
export const DialogHeader = ({ closeFunction }: { closeFunction: Function }) => {
  return (
    <View style={{ width: '100%', height: 30, backgroundColor: defaultColor, borderTopLeftRadius: 10, borderTopRightRadius: 10, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
      <TouchableOpacity onPress={() => { closeFunction() }}>
        <AntDesign name='close' size={24} color={defaultTextColor} />
      </TouchableOpacity>
    </View>
  );
}

/** ================================
*  スタイル定義
*  ================================*/
// ヘッダの色等の強調色
export const defaultColor = '#5e93ed';
// 強調色に載せる文字等の色
export const defaultTextColor = '#ffffff';
// 下地色
export const defaultBaseColor = '#f2f5f7';
// 入力欄の下地色
export const defaultBaseInputColor = '#ffffff';

// チャット色
export const chatColor = '#80aed5';

// ヘッダ高さ
export const headerHeight = 50;

export const styles = StyleSheet.create({
  fontSizeLL: {
    fontSize: 26,
  },
  fontSizeL: {
    fontSize: 20,
  },
  fontSizeM: {
    fontSize: 18,
  },
  fontSizeS: {
    fontSize: 12,
  },
  loading: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    backgroundColor: 'white',
    opacity: 0.6,
  },
  dialog: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
  dialogContents: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -headerHeight,
  },
  badgeContainer: {
    marginLeft: 'auto',
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: '#ed7d31',
    borderColor: '#ae5a21',
    minWidth: 20,
    height: 20,
    textAlign: 'center',
    borderRadius: 10,
  },
  badge: {
    color: '#ffffff',
    fontsize: 10,
  },
});
